import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useBandInvitationIdFromPath = () => {
  const { pathname } = useLocation();

  const bandInvitationId = useMemo(() => {
    const paths = pathname.split("/");
    if (paths[4] === "invitation") {
      return paths[5];
    }

    return null;
  }, [pathname]);

  return bandInvitationId;
};
